export default __webpack_public_path__ + "static/media/mail.6d46a843.svg";